import React from 'react';
interface ChartCardProps {
  title: string;
  children: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}
export function ChartCard({
  title,
  children,
  action,
  className = ''
}: ChartCardProps) {
  return <div className={`bg-white rounded-lg shadow-sm border border-slate-200 p-6 ${className}`} data-id="element-68">
      <div className="flex justify-between items-center mb-6" data-id="element-69">
        <h3 className="text-lg font-semibold text-slate-800" data-id="element-70">{title}</h3>
        {action && <div data-id="element-71">{action}</div>}
      </div>
      <div className="w-full" data-id="element-72">{children}</div>
    </div>;
}